import axios, { AxiosError, AxiosResponse } from "axios";
import { PUBLIC_URL } from "../helpers/enviroment";
import { GenericApiResponse, RefreshTokenResponse } from "interfaces";
import { useSessionStore } from "Common/Stores";
import { jwtDecode } from "jwt-decode";
import { LoginPaths } from "./services.paths";

export const api = axios.create({
  baseURL: PUBLIC_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;

const refreshToken = async () => {
  const session = useSessionStore.getState().session;

  if (!session) return;

  const response = await post<RefreshTokenResponse>(LoginPaths.getNewToken, {
    user: session.user.email,
  });

  return response;
};

api.interceptors.request.use(
  async (config) => {
    const session = useSessionStore.getState().session;
    let token = session?.token ?? null;

    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp && decodedToken.exp < currentTime && !isRefreshing) {
        try {
          isRefreshing = true;
          const response = await refreshToken();

          if (response?.code === "200" && session?.user && session?.employe) {
            useSessionStore
              .getState()
              .setSession({ ...session, token: response.data.user.token });
            token = response.data.user.token || null;
            isRefreshing = false;
          }
        } catch (error) {
          isRefreshing = false;
          throw error;
        }
      }

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.log("intercetpro: ", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;
    const session = useSessionStore.getState().session;
    if (error.response && error.response.status === 401 && session?.user) {
      try {
        const newToken = await refreshToken();
        useSessionStore
          .getState()
          .setSession({ ...session, token: newToken?.data.user.token || "" });

        if (originalRequest) {
          return api.request(originalRequest);
        }
      } catch (error: any) {
        console.log("intercetpro: ", error);
        return Promise.reject(error);
      }

      return Promise.reject(error.response);
    }
  }
);

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response) {
      console.log(error.response);
      return Promise.reject(error.response);
    }
  }
);

export const get = async <T>(url: string): Promise<GenericApiResponse<T>> => {
  try {
    const response = await api.get(url);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const post = async <T>(
  url: string,
  data: any
): Promise<GenericApiResponse<T>> => {
  try {
    const response = await api.post(url, data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const patch = async <T>(
  url: string,
  data: any
): Promise<GenericApiResponse<T>> => {
  try {
    const response = await api.patch(url, data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const put = async <T>(
  url: string,
  data: any
): Promise<GenericApiResponse<T>> => {
  try {
    const response = await api.put(url, data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const remove = async <T>(
  url: string
): Promise<GenericApiResponse<T>> => {
  try {
    const response = await api.delete(url);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteById = async <T>(
  url: string,
  id: any
): Promise<GenericApiResponse<T>> => {
  try {
    console.log("entre")
    const fullUrl = `${url}/${id}`;
    const response = await api.delete(fullUrl);

    return response.data;
  } catch (error) {
    throw error;
  }
};
